import React from 'react';


// COMPONENTS
import Avatar from 'components/common/Avatar';

const Profile = ({ fullName, email }) => {
  return (
    <div
      className="flex-shrink-0 relative flex items-center ml-4"
    >
      {/* Si fullName existe, on l’affiche ; sinon on ne met que l’avatar */}
      {fullName && (
        <p className="hidden lg:block text-xl poppins-bold pr-4 text-bleu dark:text-blanc">
          {fullName}
        </p>
      )}

      <div className="relative">
        <Avatar email={email} alt="Avatar" className="size-12" rounded={true} />
      </div>
    </div>
  );
};

export default Profile;